import React, { ReactNode } from "react";
import { Container, Stack } from "@mui/material";

const PageWrapper = ({
  children,
  withBg = true,
}: {
  children: ReactNode;
  withBg?: boolean;
}) => {
  return (
    <Stack
      sx={{
        minHeight: "calc(100vh - 100px)",
        borderRadius: 2,
        bgcolor: withBg ? "background.elevated" : "transparent",
      }}
    >
      <Container>
        <Stack gap="24px" sx={{ paddingY: "24px" }}>
          {children}
        </Stack>
      </Container>
    </Stack>
  );
};

export default PageWrapper;
